import $ from 'jquery'

$('.specs-section').on('click', function () {
  const main = $(this).find('.specs-section-main')

  $(this).toggleClass('specs-section--collapsed')
  main.slideToggle()
})
